import { withInstall } from '@xzx-design/utils'
import _Empty from './src/empty'

export const Empty = withInstall(_Empty)
export default Empty

export * from './src/empty'
export * from './src/types'
